import gql from 'graphql-tag'

export const TAB_CONTENT_BY_TABS_REF = gql`
    query Tabs($id: String!, $locale: String, $preview: Boolean) {
        tabs(id: $id, locale: $locale, preview: $preview) {
            title
            sys {
                id
            }
            tabsCollection(limit: 10) {
                total
                items {
                    ... on Tab {
                        title
                        sys {
                            id
                        }
                        content {
                            json
                            links {
                                entries {
                                    inline {
                                        sys {
                                            id
                                        }
                                        ... on Chart {
                                            __typename
                                            title
                                            subtitle
                                            height
                                            options
                                            data
                                            leaderboardType
                                            fromDateTime
                                            toDateTime
                                        }
                                        ... on Label {
                                            __typename
                                            text
                                            color
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`
